var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import { useMediaQuery } from '@mui/material';
import StepBadge from '../../../StepBadge';
function Step(_a) {
    var stepNumber = _a.stepNumber, title = _a.title, description = _a.description;
    var stepBadgeSize = useMediaQuery('(max-width: 768px)') ? 'small' : 'large';
    return (_jsx("div", __assign({ className: "w-[290px] md:w-[460px] h-full pr-md-m md:pr-0" }, { children: _jsx("div", __assign({ className: "relative w-full px-sm-m h-full py-sm-card-m md:px-md-card-m md:py-md-card-m border-2 border-border-shoe rounded-lg bg-surface-white" }, { children: _jsxs("div", __assign({ className: "flex flex-col justify-between gap-[45px] md:h-[208px]" }, { children: [_jsx("div", __assign({ className: "absolute top-[14px] right-[10px] md:right-[-1px] translate-x-[50%]" }, { children: _jsx(StepBadge, { size: stepBadgeSize, step: stepNumber }) })), _jsx(Heading, __assign({ size: "md" }, { children: title })), _jsx("p", __assign({ className: "text-sm-reg-m md:text-sm-reg-d" }, { children: description }))] })) })) })));
}
export default Step;
